// Editorial service-specific copy: examples of advisory scope, not promises or client claims.
// Keys are generated with serviceSlug from the existing capability taxonomy.
export const SERVICE_DETAILS = {
  "s-and-op-ibp": {
    intro: {
      en: "Connect demand, supply, finance and executive decision-making through a practical integrated business planning process.",
      fr: "Relier demande, approvisionnement, finance et décisions de direction au sein d'un processus de planification intégré et opérationnel.",
    },
    deliverables: {
      en: ["S&OP maturity and governance assessment", "Meeting cadence, decision rights and escalation rules", "Demand-supply-finance reconciliation design", "IBP transformation roadmap"],
      fr: ["Diagnostic de maturité S&OP et de gouvernance", "Rituels, responsabilités et règles d'escalade", "Conception de la réconciliation demande-supply-finance", "Feuille de route de transformation IBP"],
    },
  },
  "demand-planning": {
    intro: {
      en: "Improve forecast governance, planning segmentation and collaboration between commercial signals and operational demand plans.",
      fr: "Améliorer la gouvernance des prévisions, la segmentation et la collaboration entre signaux commerciaux et plans de demande.",
    },
    deliverables: {
      en: ["Forecast process assessment", "Demand planning roles and cycle design", "Planning hierarchy and segmentation recommendations", "KPI and exception-management framework"],
      fr: ["Diagnostic du processus de prévision", "Rôles et calendrier du Demand Planning", "Recommandations sur les hiérarchies et la segmentation", "Cadre de KPI et gestion par exception"],
    },
  },
  "supply-planning": {
    intro: {
      en: "Translate demand and constraints into feasible supply decisions, scenarios and cross-functional trade-offs.",
      fr: "Traduire demande et contraintes en décisions d'approvisionnement réalisables, scénarios et arbitrages transverses.",
    },
    deliverables: {
      en: ["Supply planning process and horizon design", "Constraint and capacity model requirements", "Scenario and escalation framework", "Supply planning operating model"],
      fr: ["Conception du processus et des horizons de planification", "Besoins de modélisation des contraintes et capacités", "Cadre de scénarios et d'escalade", "Modèle opérationnel de Supply Planning"],
    },
  },
  "inventory": {
    intro: {
      en: "Balance service, working capital and uncertainty using clear inventory policies and planning segmentation.",
      fr: "Arbitrer service, besoin en fonds de roulement et incertitude grâce à des politiques de stock et une segmentation explicites.",
    },
    deliverables: {
      en: ["Inventory segmentation framework", "Service and stock policy assessment", "Replenishment decision requirements", "Inventory KPI and governance design"],
      fr: ["Cadre de segmentation des stocks", "Évaluation des politiques de service et de stock", "Exigences de décision de réapprovisionnement", "Conception des KPI et de la gouvernance des stocks"],
    },
  },
  "supply-chain-strategy": {
    intro: {
      en: "Clarify the target Supply Chain capabilities, network trade-offs and operating priorities behind the business strategy.",
      fr: "Clarifier les capacités Supply Chain cibles, les arbitrages de réseau et les priorités opérationnelles liées à la stratégie de l'entreprise.",
    },
    deliverables: {
      en: ["Strategic capability assessment", "Business and operating priorities", "Target decision and process architecture", "Sequenced transformation roadmap"],
      fr: ["Évaluation des capacités stratégiques", "Priorités métier et opérationnelles", "Architecture cible des décisions et processus", "Feuille de route séquencée"],
    },
  },
  "target-operating-model": {
    intro: {
      en: "Define how planning decisions, roles, governance and enabling systems should work together across the organization.",
      fr: "Définir l'articulation entre décisions de planification, rôles, gouvernance et systèmes dans l'organisation.",
    },
    deliverables: {
      en: ["Decision rights and RACI", "Planning organization and interfaces", "Governance and meeting cadence", "Target operating model transition plan"],
      fr: ["Responsabilités décisionnelles et RACI", "Organisation de planification et interfaces", "Gouvernance et calendrier des instances", "Plan de transition vers le modèle cible"],
    },
  },
  "aps-transformation": {
    intro: {
      en: "Structure an enterprise planning transformation around business outcomes, realistic delivery waves and sustainable ownership.",
      fr: "Structurer une transformation APS autour des résultats métier, de vagues de déploiement réalistes et d'une appropriation durable.",
    },
    deliverables: {
      en: ["Transformation scope and business case assumptions", "Functional and technical roadmap", "Program governance and dependencies", "Deployment and adoption strategy"],
      fr: ["Périmètre de transformation et hypothèses de business case", "Feuille de route fonctionnelle et technique", "Gouvernance et dépendances", "Stratégie de déploiement et d'adoption"],
    },
  },
  "aps-selection": {
    intro: {
      en: "Choose enterprise planning technology using business requirements, demonstrable use cases and a transparent evaluation framework.",
      fr: "Sélectionner une technologie APS à partir des besoins métier, de cas d'usage démontrables et d'une grille d'évaluation transparente.",
    },
    deliverables: {
      en: ["Prioritized requirements and use cases", "Evaluation scorecard", "Vendor demonstration scenarios", "Recommendation and implementation considerations"],
      fr: ["Exigences et cas d'usage priorisés", "Grille d'évaluation", "Scénarios de démonstration éditeur", "Recommandation et points d'attention pour le déploiement"],
    },
  },
  "program-management": {
    intro: {
      en: "Drive complex multi-workstream planning programs across business, IT, technology vendors and regional teams.",
      fr: "Piloter des programmes de planification complexes entre métiers, IT, éditeurs et équipes régionales.",
    },
    deliverables: {
      en: ["Integrated program plan", "Decision and risk governance", "Milestone and dependency management", "Steering and escalation routines"],
      fr: ["Plan de programme intégré", "Gouvernance des décisions et des risques", "Pilotage des jalons et dépendances", "Rituels de pilotage et d'escalade"],
    },
  },
  "project-management": {
    intro: {
      en: "Coordinate project design, delivery, testing, readiness and cutover with clear accountabilities and decision points.",
      fr: "Coordonner conception, réalisation, tests, préparation opérationnelle et bascule avec des responsabilités et jalons clairs.",
    },
    deliverables: {
      en: ["Delivery plan and workstream coordination", "Milestone and issue tracking", "Decision log and governance", "Readiness and cutover coordination"],
      fr: ["Plan de livraison et coordination des chantiers", "Suivi des jalons et anomalies", "Journal des décisions et gouvernance", "Coordination de la préparation et de la bascule"],
    },
  },
  "data-management": {
    intro: {
      en: "Make planning data understandable, governed and fit for purpose across business systems and planning models.",
      fr: "Rendre les données de planification compréhensibles, gouvernées et adaptées aux usages, des systèmes sources aux modèles de planning.",
    },
    deliverables: {
      en: ["Data ownership and quality framework", "Master data mapping and business rules", "Data validation scenarios", "Readiness and remediation backlog"],
      fr: ["Gouvernance et qualité des données", "Mapping des données maîtres et règles métier", "Scénarios de validation", "Backlog de remédiation et préparation"],
    },
  },
  "integration-coordination": {
    intro: {
      en: "Bridge planning business requirements with ERP, data platforms and integration delivery teams.",
      fr: "Faire le lien entre besoins de planification, ERP, plateformes de données et équipes d'intégration.",
    },
    deliverables: {
      en: ["Source-to-target process mapping", "Interface responsibilities and dependencies", "Integration test scenarios", "Operational monitoring requirements"],
      fr: ["Mapping des processus source-cible", "Responsabilités et dépendances des interfaces", "Scénarios de tests d'intégration", "Exigences de supervision opérationnelle"],
    },
  },
  "sit-uat": {
    intro: {
      en: "Validate integrated planning scenarios and business acceptance before deployment, including critical exceptions and data conditions.",
      fr: "Valider les scénarios de planification intégrés et l'acceptation métier avant déploiement, y compris les exceptions et conditions de données critiques.",
    },
    deliverables: {
      en: ["Test strategy and business scenarios", "UAT execution governance", "Defect classification and triage", "Go/no-go readiness evidence"],
      fr: ["Stratégie de tests et scénarios métier", "Gouvernance d'exécution UAT", "Qualification et tri des anomalies", "Éléments de préparation au go/no-go"],
    },
  },
  "deployment": {
    intro: {
      en: "Prepare regional teams and operational processes for the transition to a new enterprise planning system.",
      fr: "Préparer les équipes régionales et processus opérationnels à l'adoption d'un nouveau système de planification.",
    },
    deliverables: {
      en: ["Deployment roadmap and regional readiness", "Training and super-user enablement", "Cutover prerequisites", "Go-live support model"],
      fr: ["Feuille de route et préparation régionale", "Formation et mobilisation des super-utilisateurs", "Prérequis de bascule", "Modèle de support au démarrage"],
    },
  },
  "cutover": {
    intro: {
      en: "Coordinate controlled transition from legacy planning processes to a new operating cycle with explicit owners and checkpoints.",
      fr: "Coordonner une transition maîtrisée des anciens processus vers un nouveau cycle de planification, avec responsables et contrôles explicites.",
    },
    deliverables: {
      en: ["Cutover checklist and dependencies", "Ownership and timing plan", "Reconciliation and fallback scenarios", "Go-live decision evidence"],
      fr: ["Checklist et dépendances de bascule", "Planification et responsabilités", "Scénarios de réconciliation et de repli", "Éléments de décision de mise en production"],
    },
  },
  "hypercare": {
    intro: {
      en: "Stabilize planning operations after go-live and transition from project delivery into sustainable business support.",
      fr: "Stabiliser les opérations de planification après le go-live et passer du mode projet à un support métier durable.",
    },
    deliverables: {
      en: ["Hypercare governance and triage", "Business incident prioritization", "Knowledge transfer", "RUN handover and enhancement backlog"],
      fr: ["Gouvernance hypercare et triage", "Priorisation des incidents métier", "Transfert de connaissances", "Passage au RUN et backlog d'évolution"],
    },
  },
  "forecasting-ml": {
    intro: {
      en: "Assess where statistical forecasting and machine learning improve planning decisions, with explicit benchmarks and model validation.",
      fr: "Évaluer où la prévision statistique et le machine learning améliorent les décisions de planification, avec benchmarks et validation des modèles.",
    },
    deliverables: {
      en: ["Forecast use-case framing", "Data and baseline assessment", "Evaluation metrics and validation protocol", "Integration and governance options"],
      fr: ["Cadrage du cas d'usage de prévision", "Évaluation des données et du modèle de référence", "Métriques et protocole de validation", "Options d'intégration et de gouvernance"],
    },
  },
  "optimization": {
    intro: {
      en: "Structure constrained business choices into transparent optimization problems, scenarios and human decision workflows.",
      fr: "Traduire des arbitrages métier contraints en problèmes d'optimisation, scénarios et workflows décisionnels transparents.",
    },
    deliverables: {
      en: ["Decision variables and constraint mapping", "Objective and trade-off design", "Scenario evaluation criteria", "Prototype and validation plan"],
      fr: ["Cartographie des variables et contraintes", "Définition des objectifs et arbitrages", "Critères d'évaluation des scénarios", "Plan de prototype et de validation"],
    },
  },
  "agents": {
    intro: {
      en: "Explore AI agents for bounded enterprise workflows with clear tools, data access, human oversight and failure controls.",
      fr: "Explorer des agents IA pour des workflows d'entreprise délimités, avec outils, accès aux données, supervision humaine et garde-fous.",
    },
    deliverables: {
      en: ["Agent use-case definition", "Tool and data permission model", "Evaluation and escalation criteria", "Prototype architecture and operating safeguards"],
      fr: ["Définition du cas d'usage agentique", "Modèle de permissions des outils et données", "Critères d'évaluation et d'escalade", "Architecture de prototype et garde-fous opérationnels"],
    },
  },
  "human-in-the-loop": {
    intro: {
      en: "Design decision processes where automated recommendations remain explainable, reviewable and accountable.",
      fr: "Concevoir des processus où les recommandations automatisées restent explicables, vérifiables et sous responsabilité humaine.",
    },
    deliverables: {
      en: ["Review and escalation workflow", "Decision ownership mapping", "Audit trail requirements", "Risk-based automation thresholds"],
      fr: ["Workflow de revue et d'escalade", "Cartographie des responsables de décision", "Exigences de traçabilité", "Seuils d'automatisation fondés sur les risques"],
    },
  },
  "workflow-automation": {
    intro: {
      en: "Reduce repetitive operational work by connecting reliable inputs, explicit rules, systems and human exceptions.",
      fr: "Réduire les tâches opérationnelles répétitives en reliant données fiables, règles explicites, systèmes et exceptions humaines.",
    },
    deliverables: {
      en: ["Process and trigger mapping", "Integration and exception design", "Auditability and monitoring requirements", "Prototype and deployment options"],
      fr: ["Cartographie des processus et déclencheurs", "Conception des intégrations et exceptions", "Exigences de traçabilité et supervision", "Options de prototype et de déploiement"],
    },
  },
  "decision-governance": {
    intro: {
      en: "Define how business decisions are proposed, challenged, approved, recorded and improved.",
      fr: "Définir comment les décisions métier sont proposées, challengées, approuvées, tracées et améliorées.",
    },
    deliverables: {
      en: ["Decision inventory and ownership", "Approval and escalation rules", "Decision-quality metrics", "Governance operating rhythm"],
      fr: ["Inventaire des décisions et responsabilités", "Règles d'approbation et d'escalade", "Indicateurs de qualité décisionnelle", "Rituels de gouvernance"],
    },
  },
};
